import { DrEntity } from './dr-entity';
import { DrObject } from './dr-object';

export class DataAreaViewModel extends DrObject {

    model: Partial<DataArea>;

    constructor(value?: Partial<DataArea>) {
        super();  // TODO: may need another arg to account for differnt types or create mult views for each type.
        if (value) {
            this.model = value;
        }
    }
}

export class DataArea extends DrEntity {

    static maxNameLength = 100;

    name: string;
    description: string;
    connectorType?: string;

    constructor(value?: Partial<DataArea>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
